export default __webpack_public_path__ + "static/rsz_1kamila_musiatowicz-e7cf4a9f720ddf9066c180ef4f66f787.jpg";